export default __webpack_public_path__ + "img/1b0f8cf9e7ac0c8b050e1f930816f910.png";